"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductBoxConfiguration = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
const getProductBoxConfiguration = async ({
  staticApiUrl,
  tenant
}) => {
  const client = new _staticApiClientReact.ApiClient({
    baseUrl: staticApiUrl
  });
  const {
    data: {
      isMrpStatementEnabled,
      isRatingsAndReviewsEnabled
    }
  } = await (0, _staticApiClientReact.getTenantApplicationsProductboxConfiguration)(client, tenant);
  return {
    isMrpStatementEnabled,
    isRatingsAndReviewsEnabled
  };
};
exports.getProductBoxConfiguration = getProductBoxConfiguration;